<template>
  <div class="jobList">
    <div class="wrap">
      <div class="page_tit">
        <h3>这里是行业标题</h3>
        <p class="left">
          我是描述我是描述我是描述我是描述我是描述我是描述我是描述我是描述我是描述我是描述我是描述我是描述我是描述我是描述
        </p>
      </div>
      <div class="des"></div>
      <div class="wrap">
        <div class="des_list2">
          <ul>
            <li v-for="(item,index) in 8" @click="listActive=index" :class="listActive==index?'active':''">
              <div class="box">
                <div class="img"><img src="../assets/img/img3.jpg" /></div>
                <div class="text">
                  <h3>我是名称{{ item }}</h3>
                  <p>我是单位</p>
                  <p>我是职位</p>
                  <p>我是职位</p>
                </div>
              </div>
              <div class="drop"  v-if="listActive==index">
              <div class="des">
                <p>这里是大段的多行输入，显示顾问的个人经历等信息</p>
                <p>这里是大段的多行输入，显示顾问的个人经历等信息</p>
                <p>这里是大段的多行输入，显示顾问的个人经历等信息</p>
                <p>这里是大段的多行输入，显示顾问的个人经历等信息</p>
                <p>这里是大段的多行输入，显示顾问的个人经历等信息</p>
                <p>这里是大段的多行输入，显示顾问的个人经历等信息</p>
                <p>这里是大段的多行输入，显示顾问的个人经历等信息</p>
                <p>这里是大段的多行输入，显示顾问的个人经历等信息</p>
              </div>
            </div>
            </li>
            
          </ul>
        </div>

        <div class="ht50"></div>
        <div class="next_btn">
          <a href="javascript:void(0)" @click="dialogVisible = true"
            >我要咨询</a
          >
        </div>
        <div class="ht50"></div>
      </div>
    </div>

    <el-dialog title="请选择咨询方式" :visible.sync="dialogVisible" width="30%">
      <div class="dia_c_btn">
        <span @click="dialogVisibleEwm = true">小助手</span>
        <span @click="dialogVisibleDes = true">录入信息</span>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisibleEwm">
      <div class="dia_c_ewm">
        <img src="../assets/img/bcd1b1571e0b8d970f45cdc2bb67efc.jpg" />
      </div>
    </el-dialog>
    <el-dialog title="录入信息" :visible.sync="dialogVisibleDes">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="input_list"
      >
        <el-form-item prop="name">
          <div class="flex">
            <i class="iconfont  icon-xingming"></i>
            <div class="flex1">
              <span class="pos"><label class="red">*</label>姓名</span>
              <el-input
                type="input"
                v-model="ruleForm.name"
                placeholder="请输入姓名"
              >
              </el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="school">
          <div class="flex">
            <i class="iconfont  icon-xingming"></i>
            <div class="flex1">
              <div class="pos">
                <el-select
                  v-model="ruleForm.degree"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option label="本科" value="1"></el-option>
                  <el-option label="硕士" value="2"></el-option>
                  <el-option label="博士" value="3"></el-option>
                </el-select>
              </div>
              <el-input
                type="input"
                v-model="ruleForm.school"
                placeholder="请输入毕业院校"
              >
              </el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="major">
          <div class="flex">
            <i class="iconfont  icon-zhuanyemingcheng"></i>
            <div class="flex1">
              <span class="pos"><label class="red">*</label>专业</span>
              <el-input
                type="input"
                v-model="ruleForm.major"
                placeholder="请输入专业"
              >
              </el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="graduatetime">
          <div class="flex">
            <i class="iconfont  icon-shijian"></i>
            <div class="flex1">
              <span class="pos pos2" style="margin-left: 20px;"
                ><label class="red">*</label>毕业时间</span
              >
              <el-date-picker
                style="width: 100%;"
                class="text123"
                v-model="ruleForm.graduatetime"
              ></el-date-picker>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="phone">
          <div class="flex">
            <i class="iconfont  icon-lianxifangshi"></i>
            <div class="flex1">
              <span class="pos"><label class="red">*</label>微信</span>
              <el-input
                type="input"
                v-model="ruleForm.phone"
                placeholder="请输入微信ID"
              >
              </el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="email">
          <div class="flex">
            <i class="iconfont  icon-youxiang"></i>
            <div class="flex1">
              <span class="pos"><label class="red">*</label>邮箱</span>
              <el-input
                type="input"
                v-model="ruleForm.email"
                placeholder="请输入邮箱"
              >
              </el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="flex1" prop="desc">
          <div class="flex">
            <i class="iconfont  icon-xinximiaoshu"></i>

            <el-input
              type="textarea"
              :rows="5"
              v-model="ruleForm.desc"
              placeholder="择业需求（比如：期望工作的城市，行业，薪资范围等）"
            >
            </el-input>
          </div>
        </el-form-item>
        <el-form-item prop="checked">
          <div class="btn_txt">
            <el-checkbox v-model="ruleForm.checked"
              >我已阅读并同意
              <router-link to="/agreement" target="_blank" class="c1"
                >《平台服务协议》</router-link
              ><router-link to="/agreement" target="_blank" class="c1"
                >《平台隐私政策》</router-link
              ></el-checkbox
            >
          </div>
        </el-form-item>
      </el-form>
      <div class="next_btn">
        <el-button>提交</el-button>
        <p class="next_btn_tips">
          <i class="iconfont icon-lock"></i>(您的信息已加密，请放心填写)
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisibleEwm: false,
      dialogVisibleDes: false,
      select: "1",
      checked: false,
      ruleForm: {
        name: "",
        school: "",
        graduatetime: "",
        degree: "1",
        major: "",
        region: "",
        phone: "",
        email: "",
        desc: "",
        checked: false,
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        school: [
          { required: true, message: "请输入毕业院校", trigger: "blur" },
        ],
        graduatetime: [
          { required: true, message: "请输入毕业时间", trigger: "blur" },
        ],
        major: [{ required: true, message: "请输入所学专业", trigger: "blur" }],
        phone: [{ required: true, message: "请输入微信ID", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写择业需求", trigger: "blur" }],
      },
      listActive:-1
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    openDia() {},
  },
};
</script>
<style lang="scss" scoped>
.page_tit h3 {
  font-size: 30px;
  color: #00237d;
  margin-bottom: 20px;
}
.input_list {
  width: 100%;
  margin-top: 0;
}
.next_btn {
  margin: 0px 0;
}
</style>
